import { render, staticRenderFns } from "./EditProductTags.vue?vue&type=template&id=f9e4a860"
import script from "./EditProductTags.vue?vue&type=script&lang=js"
export * from "./EditProductTags.vue?vue&type=script&lang=js"
import style0 from "./EditProductTags.vue?vue&type=style&index=0&id=f9e4a860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports